/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6.99987 16.5L5.99988 22C7.98443 21.6692 9.98033 21.2207 11.9999 21.2207C14.0132 21.2207 16.0143 21.6691 17.9999 22L16.9999 16.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="4"
				y="2"
				width="16"
				height="16"
				rx="8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="4"
				y="2"
				width="16"
				height="16"
				rx="8"
				fill="currentColor"
			/>
			<path
				d="M6.99999 16.5L6 22C7.98191 21.6697 9.98451 21.2207 12 21.2207C14.0155 21.2207 16.0181 21.6697 18 22L17 16.5M12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.4183 16.4183 18 12 18Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3.25006 10.0002C3.25006 5.16775 7.16757 1.25024 12.0001 1.25024C16.8326 1.25024 20.7501 5.16775 20.7501 10.0002C20.7501 14.8327 16.8326 18.7502 12.0001 18.7502C7.16757 18.7502 3.25006 14.8327 3.25006 10.0002Z"
				fill="currentColor"
			/>
			<path
				d="M5.73639 19.2577C5.81424 18.8296 5.85317 18.6155 5.9538 18.508C6.04803 18.4074 6.15385 18.358 6.2915 18.3505C6.43851 18.3425 6.6438 18.4595 7.0544 18.6936C8.51292 19.5252 10.201 20.0002 12.0001 20.0002C13.7991 20.0002 15.4872 19.5252 16.9457 18.6936C17.3563 18.4595 17.5616 18.3425 17.7086 18.3505C17.8463 18.358 17.9521 18.4074 18.0463 18.508C18.1469 18.6155 18.1859 18.8296 18.2637 19.2578L18.7252 21.7961C18.7937 22.1728 18.828 22.3612 18.7711 22.4976C18.7214 22.617 18.6273 22.7124 18.5087 22.7639C18.3732 22.8227 18.1843 22.7913 17.8066 22.7283L16.0854 22.4414C14.4976 22.1768 13.7528 22.0535 13.0067 22.0042C12.3364 21.9598 11.6638 21.9598 10.9934 22.0042C10.2473 22.0535 9.50249 22.1768 7.91475 22.4414L6.19349 22.7283C5.81579 22.7913 5.62694 22.8227 5.49139 22.7639C5.37278 22.7124 5.27873 22.617 5.22898 22.4976C5.17213 22.3612 5.20638 22.1728 5.27488 21.7961L5.73639 19.2577Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 16.5L18 22C16.0181 21.6697 14.0155 21.2207 12 21.2207C9.98451 21.2207 7.98191 21.6697 6 22L6.36363 20M18.9297 6C19.6104 7.17669 20 8.54285 20 10C20 14.4183 16.4183 18 12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C13.6686 2 15.2179 2.51085 16.5 3.38468"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6.99987 16.5L5.99988 22C7.98179 21.6697 9.98438 21.2207 11.9999 21.2207C14.0154 21.2207 16.018 21.6697 17.9999 22L16.9999 16.5M11.9999 18C7.5816 18 3.99988 14.4183 3.99988 10C3.99988 5.58172 7.5816 2 11.9999 2C16.4182 2 19.9999 5.58172 19.9999 10C19.9999 14.4183 16.4182 18 11.9999 18Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.25012 10C3.25012 5.16751 7.16763 1.25 12.0001 1.25C16.8326 1.25 20.7501 5.16751 20.7501 10C20.7501 14.8325 16.8326 18.75 12.0001 18.75C7.16763 18.75 3.25012 14.8325 3.25012 10Z"
				fill="currentColor"
			/>
			<path
				d="M5.73648 19.2574C5.81433 18.8292 5.85326 18.6151 5.95389 18.5077C6.04812 18.407 6.15394 18.3577 6.29159 18.3502C6.4386 18.3421 6.6439 18.4592 7.05449 18.6933C8.51301 19.5248 10.2011 19.9999 12.0002 19.9999C13.7992 19.9999 15.4873 19.5248 16.9458 18.6933C17.3564 18.4592 17.5617 18.3421 17.7087 18.3502C17.8464 18.3577 17.9522 18.407 18.0464 18.5077C18.147 18.6151 18.186 18.8292 18.2638 19.2574L18.7253 21.7957C18.7938 22.1725 18.8281 22.3608 18.7712 22.4972C18.7215 22.6166 18.6274 22.712 18.5088 22.7635C18.3733 22.8224 18.1844 22.7909 17.8067 22.728L16.0855 22.4411C14.4977 22.1765 13.7529 22.0532 13.0068 22.0038C12.3364 21.9595 11.6639 21.9595 10.9935 22.0038C10.2474 22.0532 9.50258 22.1765 7.91484 22.4411L6.19358 22.728C5.81588 22.7909 5.62703 22.8224 5.49148 22.7635C5.37287 22.712 5.27882 22.6166 5.22907 22.4972C5.17222 22.3608 5.20647 22.1725 5.27497 21.7957L5.73648 19.2574Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
